import { createFileRoute } from "@tanstack/react-router";
import { DealContractualInformationPage } from "../../../../../pages/deal-contractual-information-page/deal-contractual-information-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/contractual-information")({
  component: DealContractualInformationPage,
});
